import Vue from 'vue'
import alert from './Alert.vue'

const Alert = Vue.extend(alert);
let alertFun = options => {
    let str_num = (typeof options == 'string' || typeof options == 'number');
    const Instance = new Alert({ // 实例化组件
        data: { // data变量
            title: (options && options.title) || '',
            text: str_num ? options : ((options && options.text) || ''),
            value: (options && options.value) || '',
            cancelText: (options && options.cancel) || '取消',
            confirmText: (options && options.confirm) || '确定'
        }
    })
    let vm = Instance.$mount(); // 挂载组件
    document.body.appendChild(vm.$el); // 插入至body下
    if(options.close) {
        window.alertClose = vm;
    }
    return vm.init();
}

export default {
    install: (Vue) => {
        Vue.prototype.$alert = alertFun; // 挂载至Vue原型
    }
}